import React, { useState, useEffect, useRef } from 'react';

const TestimonialSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [count, setCount] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const intervalRef = useRef(null);
  const sectionRef = useRef(null);
  const animationStarted = useRef(false);

  const testimonials = [
    {
      name: 'Ipfone',
      role: 'Your Business Connection',
      location: 'Pittsburgh, Pennsylvania',
      text: 'Amazing software services. The solutions they\'re providing is helping our business run more smoothly. We\'ve been able to make quick developments with the meeting our product vision within the timeline we set up.',
      partnership: 'STRATEGIC TECHNOLOGY PARTNER',
      avatar: '/ipfone.png'
    },
    {
      name: 'NEC Global',
      role: 'Orchestrating a brighter World',
      location: 'Minato City, Tokyo, Japan',
      text: 'Their expertise in software development has transformed our business operations. The team\'s dedication to quality and innovation is unmatched.',
      partnership: 'INNOVATION PARTNER',
      avatar: '/NEC.png'
    },
    {
      name: 'Metro By T-Mobile',
      location: 'Richardson, Texas, United States',
      text: 'Exceptional service and outstanding results. They\'ve helped us achieve our goals faster than we thought possible.',
      partnership: 'DEVELOPMENT PARTNER',
      avatar: '/Metro.svg'
    }
  ];

  // Check for mobile screen size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Intersection Observer setup
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Counter Animation
  useEffect(() => {
    if (isVisible && !animationStarted.current) {
      animationStarted.current = true;
      const duration = 2000;
      const steps = 50;
      const stepValue = 25 / steps;
      const stepDuration = duration / steps;

      const timer = setInterval(() => {
        setCount(prevCount => {
          if (prevCount < 25) {
            return Math.min(prevCount + stepValue, 25);
          }
          clearInterval(timer);
          return 25;
        });
      }, stepDuration);

      return () => clearInterval(timer);
    }
  }, [isVisible]);

  // Auto-scroll
  useEffect(() => {
    if (!isHovered) {
      intervalRef.current = setInterval(handleNext, 5000);
    }
    return () => clearInterval(intervalRef.current);
  }, [currentSlide, isHovered]);

  const handleNext = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const styles = {
    container: {
      maxWidth: '100%',
      margin: '0 auto',
      padding: isMobile ? '10px' : '20px',
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      gap: '30px',
      fontFamily: 'Arial, sans-serif',
      position: 'relative',
    },
    statsCard: {
      flex: isMobile ? 'none' : '1',
      width: isMobile ? '100%' : 'auto',
      minWidth: isMobile ? 'auto' : '280px',
      backgroundColor: '#100D18',
      borderRadius: '10px',
      backgroundImage: 'url("abt4.png")', // Add your image path here
  backgroundSize: '650px', // Ensures the image covers the entire card
  backgroundRepeat: 'no-repeat', // Prevents the image from repeating
  backgroundPosition: 'bottom', // Centers the image within the card
      padding: isMobile ? '20px' : '30px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      position: isMobile ? 'relative' : 'sticky',
      height: '290px',
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
      transition: 'opacity 0.6s ease-out, transform 0.6s ease-out',
      zIndex: 2,
    },
    testimonialContainer: {
      flex: isMobile ? 'none' : '2',
      width: isMobile ? '100%' : 'auto',
      minWidth: isMobile ? 'auto' : '300px',
      position: 'relative',
      overflow: 'hidden',
    },
    testimonialTrack: {
      display: 'flex',
      transition: 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
      gap: '20px',
      padding: '10px',
      width: `${testimonials.length * 100}%`,
    },
    testimonialCard: {
      width: `calc(${100 / testimonials.length}% - 20px)`,
      backgroundColor: '#ffffff',
      borderRadius: '10px',
      padding: isMobile ? '20px' : '30px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.15)',
      transition: 'transform 0.3s ease',
      position: 'relative',
      flex: '1 0 auto',
    },
    partnershipText: {
      fontSize: isMobile ? '20px' : '24px',
      color: 'white',
      fontFamily: 'Oswald, sans-serif',
      fontWeight: '500',
      lineHeight:'32px',
      marginBottom: '10px',
      letterSpacing: '0.5px',
    },
    number: {
      fontSize: isMobile ? '36px' : '54px',
      color: 'white',
      fontFamily: 'Oswald, sans-serif',
      fontWeight: 'bold',
      marginBottom: '10px',
      transition: 'opacity 0.3s ease',
    },
    title: {
      fontSize: isMobile ? '20px' : '20px',
      color: 'white',
      fontFamily: 'Oswald, sans-serif',
      fontWeight: '400',
      marginTop:'22px',
      lineHeight: '1.2',
    },
    partnershipTag: {
      position: 'absolute',
      top: '20px',
      color: '#410684',
      lineHeight:'32px',
      fontFamily: 'Oswald, sans-serif',
      borderRadius: '20px',
      fontSize: isMobile ? '12px' : '20px',
      fontWeight: '700',
    },
    testimonialText: {
      fontSize: isMobile ? '16px' : '16px',
      color: '#414042',
      fontWeight: '400',
      fontFamily: 'Inter, sans-serif',
      marginBottom: '30px',
      lineHeight: '24px',
      marginTop: '40px',
    },
    profile: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: isMobile ? 'flex-start' : 'center',
      gap: '15px',
    },
    avatar: {
      width: isMobile ? '150px' : '190px',
      height: isMobile ? '60px' : '80px',
      objectFit: 'cover',
    },
    profileInfo: {
      flex: '1',
    },
    name: {
      fontSize: isMobile ? '16px' : '18px',
      fontWeight: 'bold',
      color: '#400684',
      marginBottom: '5px',
    },
    role: {
      fontSize: isMobile ? '14px' : '15px',
      color: '#414042',
      fontWeight:'400',
      fontFamily:'Inter, sans-serif',
      marginBottom: '5px',
    },
    location: {
      fontSize: isMobile ? '12px' : '14px',
      color: '#414042',
      display: 'flex',
      fontWeight:'400',
      fontFamily:'Inter, sans-serif',
      alignItems: 'center',
      gap: '5px',
    },
    navigationControls: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: 'white',
      marginTop: '0px',
    },
    navButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      backgroundColor: 'transparent', // Make the background transparent
      transition: 'all 0.3s ease',
      fontSize: isMobile ? '16px' : '18px',
      fontWeight:'bold',
      color: 'white',
      border: 'none', 
      marginTop:'-10px',
    },
    progressBar: {
      height: '4px',
      backgroundColor: '#f0f0f0',
      borderRadius: '2px',
      overflow: 'hidden',
      margin: '20px 0',
    },
    progressFill: {
      height: '100%',
      backgroundColor: '#dc2666',
      transition: 'width 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
    },
  };

  return (
    <div style={styles.container} ref={sectionRef}>
      <div style={styles.statsCard}>
        <div style={styles.partnershipText}>TRUSTED PARTNERSHIPS</div>
        <div style={styles.number}>{Math.round(count)}+</div>
        <div style={styles.title}>SUCCESSFUL PARTNERSHIPS DRIVING INNOVATION</div>
        <div style={styles.progressBar}>
          <div 
            style={{
              ...styles.progressFill,
              width: `${((currentSlide + 1) / testimonials.length) * 100}%`
            }}
          />
        </div>
        <div style={styles.navigationControls}>
          <button 
            onClick={handlePrev}
            style={{...styles.navButton, opacity: isHovered ? 1 : 0.7}}
            aria-label="Previous testimonial"
            onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
          >
            {'<<'}
          </button>
          <button 
            onClick={handleNext}
            style={{...styles.navButton, opacity: isHovered ? 1 : 0.7}}
            aria-label="Next testimonial"
            onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
          >
           {'>>'}
          </button>
        </div>
      </div>

      <div 
        style={styles.testimonialContainer}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div 
          style={{
            ...styles.testimonialTrack,
            transform: `translateX(-${currentSlide * (100 / testimonials.length)}%)`,
          }}
        >
          {testimonials.map((testimonial, index) => (
            <div key={index} style={styles.testimonialCard}>
              <div style={styles.partnershipTag}>
                {testimonial.partnership}
              </div>
              <div style={styles.testimonialText}>
                {testimonial.text}
              </div>
              <div style={styles.profile}>
                <img 
                  src={testimonial.avatar} 
                  alt={testimonial.name} 
                  style={styles.avatar}
                />
                <div style={styles.profileInfo}>
                  <div style={styles.name}>{testimonial.name}</div>
                  {testimonial.role && <div style={styles.role}>{testimonial.role}</div>}
                  <div style={styles.location}>
                    📍 {testimonial.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;